import React, { useEffect, useRef } from 'react';

import nitin from '../../assets/coreteam/Nitin Balakshi.jpg';
import sandeep from '../../assets/coreteam/Sandeep Sharma.jpeg';
import narendra from '../../assets/coreteam/narendra Singh.jpeg';
import pratibha from '../../assets/coreteam/pratibha vaidya.jpeg';
import upendra from '../../assets/coreteam/upendra singh.jpeg';
import hari from '../../assets/coreteam/Hari Thakur.jpg';
import lovekesh from '../../assets/coreteam/Lovekesh .jpeg';
import prince from '../../assets/coreteam/Prince Kumar.jpeg';
import dhanjit from '../../assets/coreteam/dhanjita das.jpeg';
import { gsap } from 'gsap';

const SecondTab = () => {
  const TeamMembers = [
    {
      name: 'Prince Kumar',
      designation: 'Assitant General Manager - TeleSales',
      imgUrl: prince,
    },
    {
      name: 'Pratibha Vaidya',
      designation: 'Sr Manager - MP & Jharkhand',
      imgUrl: pratibha,
    },
    {
      name: 'Nitin Balakshe',
      designation: 'Regional Head - ROM',
      imgUrl: nitin,
    },
    {
      name: 'Sandeep Sharma',
      designation: 'Regional Head - Gujarat',
      imgUrl: sandeep,
    },
    {
      name: 'Narendra Singh',
      designation: 'Regional Head - Rajasthan',
      imgUrl: narendra,
    },
    {
      name: 'Upendra Singh',
      designation: 'Area Head - Bikaner',
      imgUrl: upendra,
    },
    { name: 'Hari Singh', designation: 'Area Head  - Punjab', imgUrl: hari },
    {
      name: 'Lovekesh',
      designation: 'Area Head - Himanchal Pradesh',
      imgUrl: lovekesh,
    },
  ];

  const cardRefs = useRef([]);

  useEffect(() => {
    // Animate each card one by one
    cardRefs.current.forEach((card, index) => {
      gsap.fromTo(
        card,
        { y: -50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.5,
          delay: index * 0.1, // Delay each card animation
        }
      );
    });
  }, []);

  return (
    <div className="flex flex-col w-full pt-2">
      <div className="flex flex-wrap">
        {TeamMembers.map((i, index) => {
          return (
            <div
              className="w-full md:w-6/12 lg:w-3/12 mb-6 px-6 sm:px-6 lg:px-2"
              ref={(el) => (cardRefs.current[index] = el)}
            >
              <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden flex flex-col items-center p-4">
                {' '}
                {/* Added background and shadow */}
                <a href="#" className="mx-auto">
                  <img
                    className="rounded-lg w-48 h-60 md:w-60 md:h-72 object-cover transition-transform duration-200 hover:scale-105" // Ensures consistent size
                    src={i.imgUrl}
                    alt={i.name}
                  />
                </a>
                <div className="text-center mt-6">
                  <h1 className="text-slate-600 text-md md:text-sm font-bold mb-1">
                    {i.name}
                  </h1>

                  <div className="text-slate-400 font-semibold mb-2 text-base md:text-xs">
                    {i.designation}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default SecondTab;
